export default "__VITE_ASSET__DN$iZIn8__"